import React from "react";

export const BenefitCard = ({ benefit, handleClick }) => {
    return (
        <div className='benefit-card'>
            <div className="benefit-card__img-container">
                <img
                    className='benefit-card__img'
                    src={benefit.image}
                    alt={benefit.name}
                />
            </div>

            <div className='benefit-card__body'>
                <p className='benefit-card__title'>{benefit.name}</p>
                <p className='benefit-card__description'>
                    {benefit.description}
                </p>
                <p className='benefit-card__category'>{benefit.category.name}</p>
            </div>

            <span
                className='btn outline-black small'
                style={{ maxWidth: "fit-content" }}
                onClick={() => handleClick(benefit)}>
                Ver detalle
            </span>
        </div>
    );
};
